export const formatTime = (dateString, isUTC = false) => {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: isUTC ? 'UTC' : undefined
  };
  return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const getMappedLabel = (list, value) => {
  return list.find((ele) => ele.value === value)?.label || value;
};
